import type { FaireProductEntity } from "../../entity_types/product";

export const p_5bk22g9c87: FaireProductEntity = {
  token: "p_5bk22g9c87",
  type: "product",
  name: "Colored Zircon Stainless Steel 18K Gold Plated Wide Ring-FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/23f8d8b0dc6ac4e4ff10a58d6e6f87b46bc32d26f4a236db3c8801d60284aac5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1651195277e5a8c2f9e703beab1f00830844c2e213ad2773d3c13f61a5a5a047.jpeg",
    "https://cdn.faire.com/fastly/6516efb64e5aa97b17a5d34bd29fe0bbbd6fe0eb70f2e95df646be89297e6c3f.jpeg",
    "https://cdn.faire.com/fastly/d87e5da94733ff64e73403552e15cdae5597b897e91660a5941431e7ff92ba81.jpeg",
  ],
  priceDollars: 8.05,
  description:
    "Type: Ring \n\nMaterial: Stainless Steel, Cubic Zirconia, 18K Gold Plated\n\nSize: Opening Adjustable \n\nProcess: Vacuum electroplating and manual polishing\n\nSurface : High Polish\n\n\n★Made of high quality stainless steel, Lead-free, Harmless to Human Body.\n\n★Perfect jewelry gift",
  tags: [],
  msrpDollars: 16.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:36.168Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
